/* eslint-disable no-unused-vars */
import React from "react";
import {
  Container,
  Grid,
  Typography,
  Link,
  Box,
  IconButton,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const Footer = () => {
  return (
    <Box className="bg-gray-800 text-white pt-12 pb-6 py-8">
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" className="font-bold mb-4">
              Davitt Electric
            </Typography>
            <Typography paragraph className="text-white-300">
              We are your trusted partner for all electrical services, providing
              high-quality solutions for residential and commercial needs with
              reliability and expertise.
            </Typography>
            <Box className="flex space-x-2 mt-4">
              <IconButton
                aria-label="Facebook"
                className="hover:text-blue-500"
                component="a"
                href="https://www.facebook.com/DavittElectricLLC/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon sx={{ color: "white" }} />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" className="font-bold mb-4">
              Quick Links
            </Typography>
            <ul className="space-y-2 list-none p-0">
              <li>
                <Link
                  href="/"
                  className="text-gray-300 no-underline hover:text-yellow-500"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  href="/gallery"
                  className="text-gray-300 no-underline hover:text-yellow-500"
                >
                  Gallery
                </Link>
              </li>
              <li>
                <Link
                  href="/about"
                  className="text-gray-300 no-underline hover:text-yellow-500"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  href="/contact"
                  className="text-gray-300 no-underline hover:text-yellow-500"
                >
                  Contact Us
                </Link>
              </li>
              {/* <li><Link href="#" className="text-gray-300 no-underline hover:text-yellow-500">Services</Link></li> */}
              {/* <li><Link href="#" className="text-gray-300 no-underline hover:text-yellow-500">FAQs</Link></li> */}
            </ul>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" className="font-bold mb-4 py-4">
              Contact Us
            </Typography>
            <Box className="space-y-3">
              <Box className="flex items-start">
                <LocationOnIcon className="mr-2 text-yellow-500 py-4" />
                <Typography className="text-gray-300 py-4">
                  121 Marshall St Leicester, MA, 01524
                </Typography>
              </Box>
              {/* <Box className="flex items-start">
                <PhoneIcon className="mr-2 text-yellow-500 py-2" />
                <Typography className="text-gray-300">
                  (555) 123-4567
                </Typography>
              </Box> */}
              <Box className="flex items-start">
                <EmailIcon className="mr-2 text-yellow-500 py-4" />
                <Typography className="text-gray-300 py-4">
                  info@Davittelectric.com
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box className="border-t border-gray-700 mt-8 pt-6 text-center">
          <Typography className="text-gray-400">
            &copy; {new Date().getFullYear()} Davitt Electric. All Rights
            Reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
